import { Typography } from '@euler/app/components/typography';
import { aiColors, tint } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { X } from 'lucide-react-native';
import { memo } from 'react';
import { Pressable, View } from 'react-native';
import {
  CaseFilterKey,
  CaseFilterValue,
  SelectedCaseFilter,
} from '../functions/caseFilters';

/** The applied filters, a row each: its name, then its values to remove. */
export const SelectedFilters = memo(
  ({
    filters,
    onRemove,
  }: {
    filters: SelectedCaseFilter[];
    onRemove: (key: CaseFilterKey, value: CaseFilterValue) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View style={{ gap: rpx(8) }}>
        {filters.map(filter => (
          <View
            key={filter.key}
            style={{ flexDirection: 'row', alignItems: 'flex-start' }}
          >
            <Typography.Text
              size={rpx(12)}
              color={aiColors.mutedForeground}
              style={{ marginTop: rpx(4), marginRight: rpx(4) }}
            >
              {`${filter.title}:`}
            </Typography.Text>
            <View
              style={{
                flex: 1,
                flexDirection: 'row',
                flexWrap: 'wrap',
                gap: rpx(6),
              }}
            >
              {filter.options.map(option => (
                <Pressable
                  key={String(option.value)}
                  onPress={() => onRemove(filter.key, option.value)}
                  accessibilityRole="button"
                  accessibilityLabel={`移除${option.label}`}
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: rpx(4),
                    borderRadius: rpx(999),
                    paddingLeft: rpx(10),
                    paddingRight: rpx(7),
                    paddingVertical: rpx(3),
                    backgroundColor: tint(aiColors.primary, 0.1),
                  }}
                >
                  <Typography.Text
                    size={rpx(12)}
                    medium
                    color={aiColors.primary}
                  >
                    {option.label}
                  </Typography.Text>
                  <X size={rpx(12)} color={aiColors.primary} />
                </Pressable>
              ))}
            </View>
          </View>
        ))}
      </View>
    );
  },
);
